import Settings from "../components/settings/Settings";
import { useAuth } from "../contexts/AuthContext";

const SettingsPage = () => {
  const { user } = useAuth();
  
  if (!user || user.role !== 'su') {
    return null;
  }

  return <Settings />;
}

export default SettingsPage;
